import { DocumentNode, QueryHookOptions, useQuery } from '@apollo/client';

export const createUseQueryHook = <T, U>(
  query: DocumentNode,
  // Optionally pass in a reducer to hydrate the options passed into the function
  // with some default properties (maybe we always prefer a certain fetch-policy
  // with this query, etc.)
  hydrateOptions?: (options?: QueryHookOptions<T, U>) => QueryHookOptions<T, U>
) => {
  return function useQueryCustom(options?: QueryHookOptions<T, U>) {
    return useQuery<T, U>(
      query,
      hydrateOptions ? hydrateOptions(options) : options
    );
  };
};
